import React, { useState, useEffect } from 'react';

const ScvImportModal = ({ isOpen, onClose, onImportSuccess, defaultName, defaultDept }) => {
    const [hoTen, setHoTen] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [errorMsg, setErrorMsg] = useState('');

    const [isDesktop, setIsDesktop] = useState(true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isOpen && defaultName) {
            setHoTen(defaultName);
        }
    }, [isOpen, defaultName]);

    if (!isOpen) return null;

    const handlePreview = async () => {
        if (!hoTen.trim()) {
            setErrorMsg("Vui lòng nhập Họ và tên giảng viên!");
            return;
        }

        setIsLoading(true);
        setErrorMsg('');
        setPreviewData(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/scvpreview`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    hoTen: hoTen.trim(),
                    donVi: defaultDept || ''
                })
            });

            if (response.ok) {
                const result = await response.json();
                setPreviewData(result);
            } else {
                const errData = await response.json();
                setErrorMsg(errData.message || "Lỗi không xác định");
            }
        } catch (error) {
            setErrorMsg("Lỗi kết nối máy chủ!");
        } finally {
            setIsLoading(false);
        }
    };

    const handleImport = async () => {
        if (!previewData) return;
        try {
            setIsLoading(true);

            const userStr = localStorage.getItem('user');
            const currentUser = userStr ? JSON.parse(userStr) : null;

            if (!currentUser || !currentUser.Id) {
                alert("Lỗi: Không tìm thấy thông tin tài khoản đăng nhập!");
                setIsLoading(false);
                return;
            }

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/scvimport?userId=${currentUser.Id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(previewData)
            });

            if (response.ok) {
                alert("Đã nhập dữ liệu từ SCV vào hồ sơ thành công!");
                if (onImportSuccess) onImportSuccess();
                onClose();
            } else {
                const errData = await response.json();
                alert("Lỗi khi lưu dữ liệu: " + (errData.message || "Không xác định"));
            }
        } catch (error) {
            console.error("Lỗi import SCV:", error);
            alert("Lỗi kết nối máy chủ khi lưu dữ liệu!");
        } finally {
            setIsLoading(false);
        }
    };

    const sortHistoryStrings = (histories) => {
        if (!histories || histories.length === 0) return [];
        return [...histories].sort((a, b) => {
            const getEndYearFromString = (str) => {
                const lowerStr = str.toLowerCase();
                if (lowerStr.includes('nay') || lowerStr.includes('hiện tại')) return 9999;

                const endMatch = str.match(/(?:-|\sđến\s)\s*(?:\d{1,2}\/)?(\d{4})/);
                if (endMatch) return parseInt(endMatch[1]);

                const firstMatch = str.match(/(?:\d{1,2}\/)?(\d{4})/);
                return firstMatch ? parseInt(firstMatch[1]) : 0;
            };

            const endA = getEndYearFromString(a);
            const endB = getEndYearFromString(b);

            return endB - endA;
        });
    };

    const personalInfoLabels = [
        { label: 'Họ tên', key: 'fullName' },
        { label: 'Giới tính', key: 'gender' },
        { label: 'Năm sinh', key: 'birthDate' },
        { label: 'Nơi sinh', key: 'birthPlace' },
        { label: 'Quê quán', key: 'hometown' },
        { label: 'Tốt nghiệp đại học', key: 'university' },
        { label: 'Đơn vị công tác', key: 'workplace' },
        { label: 'Chức vụ', key: 'position' },
        { label: 'Học vị', key: 'degree' },
        { label: 'Dạy chuyên ngành', key: 'teachingMajor' },
        { label: 'Lĩnh vực nghiên cứu', key: 'researchField' },
        { label: 'Ngoại ngữ', key: 'foreignLanguage' },
        { label: 'Điện thoại', key: 'phone' },
        { label: 'Email', key: 'email' }
    ];

    return (
        <div className="modal-overlay" style={{ zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-box" style={{
                width: isDesktop ? '1000px' : '95vw',
                maxWidth: '100%',
                margin: '10px',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#fff',
                borderRadius: '8px',
                boxSizing: 'border-box'
            }}>

                <div style={{ padding: '15px 20px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '20px', color: '#333' }}>Nhập dữ liệu từ SCV</h2>
                        <p style={{ margin: '5px 0 0 0', fontSize: '13px', color: '#666' }}>Vui lòng cung cấp chính xác đường dẫn của bạn trên hệ thống scv.udn.vn</p>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#888' }}>&times;</button>
                </div>

                <div style={{ padding: '20px', overflowY: 'auto', flex: 1 }}>
                    <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', fontWeight: 'bold', marginBottom: '8px', color: '#333' }}>Họ và tên giảng viên trên SCV <span style={{ color: 'red' }}>*</span></label>
                        <div style={{ display: 'flex', gap: '10px', flexDirection: isDesktop ? 'row' : 'column' }}>
                            <input
                                type="text"
                                className="form-input"
                                placeholder="Hệ thống tự động đồng bộ theo tài khoản"
                                style={{ flex: 1, padding: '10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', width: '100%', backgroundColor: '#e9ecef', cursor: 'not-allowed', fontWeight: 'bold', color: '#555' }}
                                value={hoTen}
                                disabled={true}
                                onChange={(e) => setHoTen(e.target.value)}
                            />
                            <button
                                onClick={handlePreview}
                                disabled={isLoading}
                                style={{ padding: '10px 20px', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px', cursor: isLoading ? 'not-allowed' : 'pointer', fontWeight: 'bold', color: '#333', width: isDesktop ? 'auto' : '100%' }}
                            >
                                {isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Xem trước"}
                            </button>
                        </div>
                        {errorMsg && <p style={{ color: '#e74c3c', fontSize: '13px', marginTop: '8px' }}>{errorMsg}</p>}
                    </div>

                    <div style={{ backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '4px', fontSize: '13px', color: '#555', marginBottom: '25px', lineHeight: '1.6' }}>
                        <p style={{ margin: '0 0 5px 0' }}><strong>Cập nhật chức năng Import:</strong> Hệ thống sẽ chạy các tác vụ ngầm để xử lý dữ liệu của Quý Thầy/Cô. Sau khi hoàn tất, Thầy/Cô sẽ nhận được email thông báo kết quả.</p>
                        <p style={{ margin: '0 0 5px 0' }}>Vui lòng không thực hiện lại chức năng này cho đến khi nhận email thông báo mới.</p>
                        <p style={{ margin: 0, color: '#e74c3c' }}>Lưu ý: Việc lấy dữ liệu theo địa chỉ website SCV không đảm bảo đầy đủ thông tin 100%. Vì vậy, sau khi thực hiện hành động này, Thầy/Cô cần vào kiểm tra và cập nhật dữ liệu.</p>
                    </div>

                    {!previewData ? (
                        <div style={{ animation: 'fadeIn 0.5s' }}>
                            <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Thông tin cá nhân</h3>
                            <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '14px', border: '1px solid #ddd' }}>
                                    <tbody>
                                        {personalInfoLabels.map((item, idx) => (
                                            <tr key={idx} style={{ borderBottom: '1px solid #ddd' }}>
                                                <td style={{ padding: '10px', fontWeight: 'bold', width: '50%', minWidth: '150px', textAlign: 'center', borderRight: '1px solid #ddd', color: '#333' }}>{item.label}</td>
                                                <td style={{ padding: '10px', width: '50%', minWidth: '150px' }}></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : (
                        <div style={{ animation: 'fadeIn 0.5s' }}>

                            {previewData.personalInfo && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Thông tin cá nhân</h3>

                                    {!isDesktop && previewData.personalInfo.avatarUrl && (
                                        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                            <img
                                                src={previewData.personalInfo.avatarUrl}
                                                alt="Avatar SCV"
                                                style={{ width: '120px', height: '160px', borderRadius: '4px', objectFit: 'cover', border: '1px solid #eee' }}
                                                onError={(e) => e.target.style.display = 'none'}
                                            />
                                        </div>
                                    )}

                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '14px', border: '1px solid #ddd' }}>
                                            <tbody>
                                                {personalInfoLabels.map((item, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #ddd' }}>

                                                        {isDesktop && idx === 0 && previewData.personalInfo.avatarUrl && (
                                                            <td rowSpan={personalInfoLabels.length} style={{ width: '150px', padding: '10px', textAlign: 'center', verticalAlign: 'top', borderRight: '1px solid #ddd', backgroundColor: '#fff' }}>
                                                                <img
                                                                    src={previewData.personalInfo.avatarUrl}
                                                                    alt="Avatar SCV"
                                                                    style={{ width: '100%', maxWidth: '130px', borderRadius: '4px', objectFit: 'cover', border: '1px solid #eee' }}
                                                                    onError={(e) => e.target.style.display = 'none'}
                                                                />
                                                            </td>
                                                        )}

                                                        <td style={{
                                                            padding: '10px',
                                                            fontWeight: 'bold',
                                                            width: (isDesktop && previewData.personalInfo.avatarUrl) ? '30%' : '40%',
                                                            minWidth: isDesktop ? '150px' : '110px',
                                                            textAlign: 'center',
                                                            borderRight: '1px solid #ddd',
                                                            color: '#333'
                                                        }}>
                                                            {item.label}
                                                        </td>
                                                        <td style={{
                                                            padding: '10px',
                                                            width: (isDesktop && previewData.personalInfo.avatarUrl) ? '55%' : '60%',
                                                            minWidth: isDesktop ? '200px' : 'auto',
                                                            color: '#333'
                                                        }}>
                                                            {previewData.personalInfo[item.key] || '---'}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {previewData.workHistories && previewData.workHistories.length > 0 && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Quá trình công tác</h3>
                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '13px', border: '1px solid #ddd' }}>
                                            <tbody>
                                                {sortHistoryStrings(previewData.workHistories).map((work, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '10px', textAlign: 'center', width: '5%', borderRight: '1px solid #ddd' }}>{idx + 1}</td>
                                                        <td style={{ padding: '10px', minWidth: '300px' }}>{work}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                            {previewData.teachingHistories && previewData.teachingHistories.length > 0 && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Quá trình giảng dạy</h3>
                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '13px', border: '1px solid #ddd' }}>
                                            <tbody>
                                                {sortHistoryStrings(previewData.teachingHistories).map((teach, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #eee' }}>
                                                        <td style={{ padding: '10px', textAlign: 'center', width: '5%', borderRight: '1px solid #ddd' }}>{idx + 1}</td>
                                                        <td style={{ padding: '10px', minWidth: '300px' }}>{teach}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {previewData.projects && previewData.projects.length > 0 && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Các công trình khoa học</h3>
                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', minWidth: '700px', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '13px', border: '1px solid #ddd' }}>
                                            <thead style={{ backgroundColor: '#fff', textAlign: 'left' }}>
                                                <tr>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>#</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Cấp đề tài</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tên đề tài</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Chủ nhiệm</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Mã số</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Năm</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {previewData.projects.map((proj, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{idx + 1}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{proj.level || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                                            {proj.name || '---'}<br />
                                                            {proj.members && proj.members.length > 0 && (
                                                                <span style={{ color: '#666', fontSize: '12px' }}>Các thành viên: {proj.members.join(', ')}</span>
                                                            )}
                                                        </td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{proj.manager || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{proj.code || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{proj.year || '---'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {previewData.articles && previewData.articles.length > 0 && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Các bài báo, báo cáo khoa học</h3>
                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', minWidth: '800px', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '13px', border: '1px solid #ddd' }}>
                                            <thead style={{ backgroundColor: '#fff', textAlign: 'left' }}>
                                                <tr>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>#</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Phạm vi</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Loại</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tiêu đề</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tạp chí/Hội thảo</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tập/Trang</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Năm</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {previewData.articles.map((art, idx) => {
                                                    let displayTitle = art.title || '---';
                                                    let displayJournal = art.journal || '---';

                                                    if (displayJournal.includes("•") || displayJournal.toLowerCase().includes("tác giả")) {
                                                        const lastBullet = displayJournal.lastIndexOf("•");
                                                        if (lastBullet > -1) {
                                                            const authorsSection = displayJournal.substring(0, lastBullet + 1).trim();
                                                            const actualJournal = displayJournal.substring(lastBullet + 1).trim();

                                                            displayTitle = (
                                                                <div>
                                                                    <div style={{ fontWeight: '500', marginBottom: '4px' }}>{art.title || '---'}</div>
                                                                    <div style={{ color: '#555', fontSize: '12.5px', fontStyle: 'italic' }}>{authorsSection}</div>
                                                                </div>
                                                            );
                                                            displayJournal = actualJournal;
                                                        }
                                                    }

                                                    return (
                                                        <tr key={idx}>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{idx + 1}</td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{art.scope || '---'}</td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{art.type || '---'}</td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{displayTitle}</td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd', fontWeight: '500' }}>{displayJournal}</td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                                                {art.issue ? `Số: ${art.issue} ` : ''}
                                                                {art.page ? `Trang: ${art.page}` : ''}
                                                            </td>
                                                            <td style={{ padding: '10px', border: '1px solid #ddd' }}>{art.year || '---'}</td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {previewData.books && previewData.books.length > 0 && (
                                <>
                                    <h3 style={{ fontSize: '16px', borderBottom: '2px solid #eee', paddingBottom: '10px', marginBottom: '15px', color: '#2c3e50', fontWeight: 'normal' }}>Sách và giáo trình</h3>
                                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch', width: '100%' }}>
                                        <table style={{ width: '100%', minWidth: '700px', borderCollapse: 'collapse', marginBottom: '30px', fontSize: '13px', border: '1px solid #ddd' }}>
                                            <thead style={{ backgroundColor: '#fff', textAlign: 'left' }}>
                                                <tr>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>#</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Tiêu đề</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Chủ biên</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Đồng chủ biên / Thành viên</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Nơi xuất bản</th>
                                                    <th style={{ padding: '10px', border: '1px solid #ddd' }}>Năm</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {previewData.books.map((book, idx) => (
                                                    <tr key={idx}>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>{idx + 1}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd', fontWeight: 'bold' }}>{book.title || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{book.chiefEditor || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                                            {book.coEditors && book.coEditors.length > 0 ? book.coEditors.join(', ') : '---'}
                                                        </td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{book.publisher || '---'}</td>
                                                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>{book.year || '---'}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>

                <div style={{ padding: '15px 20px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', gap: '10px', backgroundColor: '#fafafa' }}>
                    <button onClick={onClose} style={{ padding: '8px 20px', backgroundColor: '#888', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Hủy</button>
                    <button
                        onClick={handleImport}
                        disabled={!previewData}
                        style={{ padding: '8px 20px', backgroundColor: previewData ? '#0056b3' : '#ccc', color: '#fff', border: 'none', borderRadius: '4px', cursor: previewData ? 'pointer' : 'not-allowed' }}
                    >
                        Hoàn tất
                    </button>
                </div>
            </div>
            <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
};

export default ScvImportModal;